/* eslint-disable @typescript-eslint/no-use-before-define */
import { isRunningTest } from '../Util/Helper';
import { EnvironmentConfig } from './types';

const getEnvConfigByKey = (
  envToConfigs: { [env: string]: EnvironmentConfig },
  key: string
): string | null => {
  try {
    return getEnvConfigs(envToConfigs)[key];
  } catch (err) {
    // Prevent unnecessary logs during test runs.
    if (!isRunningTest()) {
      // Using the frontend logger here creates a cyclic dependency.
      // TODO: untangle dependencies and switch to frontend logger.
      // eslint-disable-next-line no-console
      console.error(`Environment config for key=${key} not found`);
    }
    return null;
  }
};

const getEnvConfigs = (envToConfigs: {
  [env: string]: any;
}): EnvironmentConfig => {
  return envToConfigs[getEnvKey()];
};

const getEnvKey = (): string => {
  const host = window.location.hostname;
  let key = DOMAIN_TO_ENV[host];

  // Default for dev desktops
  if (!key && host.endsWith('amazon.com')) {
    key = 'beta_na';
  }

  // Overrides the default on dev desktops. Do not use for prod.
  const override = process.env.REACT_APP_BACKEND_OVERRIDE;
  if (override) {
    key = override as string;
  }

  return key;
};

export const DOMAIN_TO_ENV: { [domain: string]: string } = {
  'beta.inspire.cs.amazon.dev': 'beta_na',
  'na-gamma.inspire.cs.amazon.dev': 'gamma_na',
  'eu-gamma.inspire.cs.amazon.dev': 'gamma_eu',
  'fe-gamma.inspire.cs.amazon.dev': 'gamma_fe',
  'cn-gamma.inspire.a2z.org.cn': 'gamma_cn',
  'na.inspire.cs.amazon.dev': 'prod_na',
  'eu.inspire.cs.amazon.dev': 'prod_eu',
  'fe.inspire.cs.amazon.dev': 'prod_fe',
  'cn.inspire.a2z.org.cn': 'prod_cn',
};

const isNARegion = (): boolean => {
  const envKey = getEnvKey();
  return envKey.endsWith('_na');
};

export default {
  getEnvConfigByKey,
  getEnvConfigs,
  getEnvKey,
  isNARegion,
};
